export default (theme) => ({
  warning: {
    color: theme.palette.primary.auxiliary,
    fontWeight: 500,
  },
  typographySpacing: {
    marginBottom: theme.spacing(3),
  },
});
